import { render, staticRenderFns } from "./new-ticket.vue?vue&type=template&id=653f1fcc"
import script from "./new-ticket.vue?vue&type=script&lang=js"
export * from "./new-ticket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports